import { jsx as _jsx } from "react/jsx-runtime";
import clsx from "clsx";
import { Popup as MapGlPopup } from "react-map-gl";
import styles from "./marker-popup.module.css";
export const MarkerPopup = (props) => {
    const { className, longitude, latitude, onClose, children, maxWidth = "210px", } = props;
    return (_jsx(MapGlPopup, { longitude: longitude, latitude: latitude, onClose: onClose, className: clsx(styles.root, className), maxWidth: maxWidth, children: children }));
};
export default MarkerPopup;
